export default __webpack_public_path__ + "static/media/4.53ba8770.jpg";